import immutable from 'immutable'
import _ from 'lodash'
import Guid from 'guid'

import deeplinksUtil from '../util/deeplinks.util'
import legUtil from '../util/leg.util'
import jotUtil from '../util/jot.util'
import jot from '../jot'


export const ACTIVATE_LEG = 'ACTIVATE_LEG'
export const ACTIVATE_LEG_BY_HASHTAG = 'ACTIVATE_LEG_BY_HASHTAG'
export const ADD_LEG = 'ADD_LEG'
export const MOVE_LEGS = 'MOVE_LEGS'
export const RESIZE_LEGS = 'RESIZE_LEGS'
export const DELETE_LEG = 'DELETE_LEG'
export const ADD_ACCOMMODATION = 'ADD_ACCOMMODATION'
export const UPDATE_ACCOMMODATION_RESERVATION = 'UPDATE_ACCOMMODATION_RESERVATION'
export const REMOVE_ACCOMMODATION = 'REMOVE_ACCOMMODATION'
export const ADD_ACTIVITY = 'ADD_ACTIVITY'
export const UPDATE_ACTIVITY_RESERVATION = 'UPDATE_ACTIVITY_RESERVATION'
export const REMOVE_ACTIVITY = 'REMOVE_ACTIVITY'

export const ADD_DESTINATION_ACCOMMODATION = 'ADD_DESTINATION_ACCOMMODATION'
export const ADD_DESTINATION_ACTIVITY = 'ADD_DESTINATION_ACTIVITY'

export function moveLegs(legs) {
    return {
        type: MOVE_LEGS,
        legs,
    }
}

export function resizeLegs(legs) {
    return {
        type: RESIZE_LEGS,
        legs,
    }
}

export function activateLeg(leg) {
    return {
        type: ACTIVATE_LEG,
        leg
    }
}

export function activateLegByHashtag(legId) {
    return {
        type: ACTIVATE_LEG_BY_HASHTAG,
        legId
    }
}

export function addLeg(startDay, legLength) {
    const newLeg = immutable.fromJS({
        // ntd -- handle leg id
        'id': Guid.raw(),
        'properties': {
            'start': startDay,
            'end': startDay + legLength,
            'sequence': 0,
            'length': legLength,
        },
        'destination': {
            'title': '',
            'longitude': '',
            'latitude': '',
            'type': '',
            'overview': '',
            'hasLocation': false,
            'id': -1
        },
        'accommodations': [],
        'taxonomy': [],
        'media': [],
        'activities': [],
        'transportation': []
    })

    deeplinksUtil.pushDeepLink('LEG', {'leg': newLeg})

    return {
        type: ADD_LEG,
        leg: newLeg,
    }
}

export function addLegDestinationAndAccom(startDay, dest, accom, user) {
    // create a new leg

    // format the destination
    let newDest = legUtil.formatDestination(dest)
    // format the accomm
    let newAccom = legUtil.formatAccommodation(accom, user)
    // make a new leg and stick everything in it
    const newLeg = immutable.fromJS({
        // ntd -- handle leg id
        'id': Guid.raw(),
        'properties': {
            'start': startDay,
            'end': startDay + 1,
            'sequence': 0,
            'length': 1,
        },
        'destination': newDest,
        'accommodations': [newAccom],
        'taxonomy': [],
        'media': [],
        'activities': [],
        'transportation': []
    })

    return {
        type: ADD_LEG,
        leg: newLeg,
    }
}

export function addDestinationAndAccom(leg, destination, accommodation, user) {
    // update leg
    return {
        type: ADD_DESTINATION_ACCOMMODATION,
        leg,
        destination,
        accommodation,
        user
    }
}

export function addLegDestinationAndActivity(startDay, dest, act, user) {
    // create a new leg

    // format the destination
    let newDest = legUtil.formatDestination(dest)
    // format the accomm
    let newAct = legUtil.formatActivity(act, user)
    // make a new leg and stick everything in it
    const newLeg = immutable.fromJS({
        // ntd -- handle leg id
        'id': Guid.raw(),
        'properties': {
            'start': startDay,
            'end': startDay + 1,
            'sequence': 0,
            'length': 1,
        },
        'destination': newDest,
        'accommodations': [],
        'taxonomy': [],
        'media': [],
        'activities': [newAct],
        'transportation': []
    })

    return {
        type: ADD_LEG,
        leg: newLeg,
    }
}

export function addDestinationAndActivity(leg, destination, activity, user) {
    // update leg
    return {
        type: ADD_DESTINATION_ACTIVITY,
        leg,
        destination,
        activity,
        user
    }
}

export function addLegAndDestination(startDay, destination) {
    const newLeg = immutable.fromJS({
        // ntd -- handle leg id
        'id': Guid.raw(),
        'properties': {
            'start': startDay,
            'end': startDay + 1,
            'sequence': 0,
            'length': 1,
        },
        'destination': destination,
        'accommodations': [],
        'taxonomy': [],
        'media': [],
        'activities': [],
        'transportation': []
    })

    return {
        type: ADD_LEG,
        leg: newLeg,
    }
}

export function deleteLeg(leg) {
    return {
        type: DELETE_LEG,
        leg,
        generateJOT: function (state) {
            let legs = state.getIn(['document', 'legs'])
            let deleteIdx = legs.findIndex((stateLeg) => {
                return stateLeg.get('id') === leg.get('id')
            })

            let deleteLeg = legs.get(deleteIdx).toJS()

            return {
                forward: jotUtil.reduce(['legs'], new jot.DEL(deleteIdx, _.castArray(deleteLeg))),
                reverse: jotUtil.reduce(['legs'], new jot.INS(deleteIdx, _.castArray(deleteLeg))),
            }
        }
    }
}

export function onUpdateAccommodationReservation(leg, accommodation) {
    return {
        type: UPDATE_ACCOMMODATION_RESERVATION,
        leg,
        accommodation
    }
}


export function onSelectAccommodation(leg, accommodation, user) {
    return {
        type: ADD_ACCOMMODATION,
        leg,
        accommodation,
        user
    }
}

export function onRemoveAccommodation(leg, accommodation) {
    return {
        type: REMOVE_ACCOMMODATION,
        leg,
        accommodation
    }
}

export function onSelectActivity(leg, activity, user) {
    return {
        type: ADD_ACTIVITY,
        leg,
        activity,
        user
    }
}

export function onUpdateActivityReservation(leg, activity) {
    return {
        type: UPDATE_ACTIVITY_RESERVATION,
        leg,
        activity
    }
}

export function onRemoveActivity(leg, activity) {
    return {
        type: REMOVE_ACTIVITY,
        leg,
        activity
    }
}
